import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ContractRequestDTO } from '../dtos/request-dto/contract-request';
import { CustomerActivationRequestDTO } from '../dtos/request-dto/customer-activation-request';
import { TestActivationRequestDTO } from '../dtos/request-dto/test-activation-request';
import { ContractResponse } from '../dtos/response-dto/contract-response';
import { CustomerActivationResponse } from '../dtos/response-dto/customer-activation-response';
import { TestActivationResponse } from '../dtos/response-dto/test-activation.response';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    private readonly REPORT_TEST_ACTIVATION = environment.baseUrl + 'Report/testActivation';
    private readonly REPORT_CONTRACT = environment.baseUrl + 'Report/contract';
    private readonly REPORT_CUSTOMER_SUPPORT = environment.baseUrl + 'Report/customerSupportActivation';

    public constructor(private http: HttpClient) { }

    public postReportTestActivation(data: TestActivationRequestDTO): Observable<TestActivationResponse> {
        return this.http.post<TestActivationResponse>(this.REPORT_TEST_ACTIVATION, data);
    }

    public postReportContract(data: ContractRequestDTO): Observable<ContractResponse> {
        return this.http.post<ContractResponse>(this.REPORT_CONTRACT, data);
    }

    public postReportCustomerService(data: CustomerActivationRequestDTO): Observable<CustomerActivationResponse> {
        return this.http.post<CustomerActivationResponse>(this.REPORT_CUSTOMER_SUPPORT, data);
    }
}
